import {useGlobalProperties} from './useGlobalProperties';
import {ComponentCustomProperties} from 'vue';

/**
 *
 * Shortcut for accessing global properties like $msg and $icu
 * Also works as a workaround for using $msg in <script setup/>
 *
 * @example
 *  ```ts
 *  setup() {
 *     const {msg, icu, requireMsg} = useTranslation();
 *  }
 *  ```
 */
export function useTranslation() {
    const app = useGlobalProperties() as ComponentCustomProperties;

    return {
        msg: app.$msg,
        icu: app.$icu,
        d: app.$d,
        $requireMsg: app.$requireMsg,
    };
}
